import React from 'react';
import {
  CardFirstRow,
  CardSecondRow,
  CardThirdRow,
  CardFourthRow,
  LineSeparetor,
  CardFifthRow,
  ExecPhoto,
  ExecPhotoWrapper,
  MoreExecContainer,
  StatusIcon,
} from '../shared/styled';
import { ReactComponent as PendingAgIcon } from 'assets/icons/pending-ag-icon.svg';
import { ReactComponent as CheckGIcon } from 'assets/icons/check-g.svg';
import { ReactComponent as ExecutorNoPhotoIcon } from 'assets/icons/executor-no-photo-icon.svg';
import { CalendarEvent, EventColorSet } from 'pages/Agenda/utils';
import { useHoverCardPosition } from '../../../hooks/useHoverCardPosition';
import { useEventCardDisplay } from '../../../hooks/useEventCardDisplay';

interface HoverCardProps {
  event: CalendarEvent;
  rect: DOMRect;
  colorSet: EventColorSet;
  isCompletedView: boolean;
}

export const HoverCard: React.FC<HoverCardProps> = ({ event, rect: initialRect, colorSet, isCompletedView }) => {
  const { positionStyle } = useHoverCardPosition(event.id, initialRect, colorSet);
  const { atividadesLabel, executorCount, firstExecutor, displayExecutors } = useEventCardDisplay(event);

  return (
    <div style={positionStyle}>
      <CardFirstRow fontColor={colorSet.fontColor}>
        <span>
          {event.time} • {event.title}
        </span>
        <StatusIcon color="transparent">
          {event.realizada || isCompletedView ? (
            <CheckGIcon width={16} height={16} />
          ) : event.atrasada ? (
            <PendingAgIcon width={12} height={12} />
          ) : null}
        </StatusIcon>
      </CardFirstRow>
      <CardSecondRow>{event.aplicacao}</CardSecondRow>
      <CardThirdRow>{event.equipamento}</CardThirdRow>
      <CardFourthRow>
        {executorCount === 1 && firstExecutor ? (
          <>
            {firstExecutor.avatar ? (
              <ExecPhoto src={firstExecutor.avatar} alt={firstExecutor.nome} />
            ) : (
              <ExecPhotoWrapper>
                <ExecutorNoPhotoIcon width={20} height={20} />
              </ExecPhotoWrapper>
            )}
            <span
              style={{
                marginLeft: '6px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {firstExecutor.nome}
            </span>
          </>
        ) : (
          <MoreExecContainer>
            <div>
              {displayExecutors.map((exec, index) =>
                exec.avatar ? (
                  <ExecPhoto
                    key={`exec-hover-${exec.nome}-${index}`}
                    src={exec.avatar}
                    alt={exec.nome}
                    style={{
                      marginLeft: index === 0 ? 0 : -8,
                      zIndex: index,
                      position: 'relative',
                    }}
                  />
                ) : (
                  <ExecPhotoWrapper
                    key={`exec-hover-${exec.nome}-${index}`}
                    style={{
                      marginLeft: index === 0 ? 0 : -8,
                      zIndex: index,
                      position: 'relative',
                    }}
                  >
                    <ExecutorNoPhotoIcon width={20} height={20} />
                  </ExecPhotoWrapper>
                ),
              )}
              <span>{executorCount} executores</span>
            </div>
          </MoreExecContainer>
        )}
      </CardFourthRow>
      <LineSeparetor separetorColor={colorSet.separetorColor} />
      <CardFifthRow>{atividadesLabel}</CardFifthRow>
    </div>
  );
};
